import React from "react"
import Loader from "react-loader-spinner"

import "./modal-loading.scss"
export default function ModalLoading({ msg }) {
  return (
    <div className="modal-loading">
      <div className="modal-loading-container">
        <Loader type="TailSpin" color="#FFFFFF" height={80} width={80} />
        {msg && <p className="family-H-Medium size-16 color-white">{msg}</p>}
      </div>
    </div>
  )
}
